













import { createComponent, computed } from '@vue/composition-api';
import WebPanel from '@sbvr/web-panel/WebPanel.vue';

import Icon from '@sbvr/common/legacy-shared/components/Icons.vue';
import useUserDropdownItems from '@sbvr/common/user/useUserDropdownItems';
import ProjectIcons from './core/components/ProjectIcons.vue';

import { useI18n } from '@/core/i18n';
import { useStore } from '@/core/store';
import { useRouter } from '@/core/routes';

export default createComponent({
  name: 'App',
  components: {
    Icon,
    ProjectIcons,
    WebPanel,
  },
  setup () {
    const i18n = useI18n();
    const store = useStore();
    const router = useRouter();

    const navigation = computed(() => [
      [
        {
          name: i18n.t('Devices'),
          routerLink: { name: 'device-index' },
          icon: 'device',
        },
        {
          name: i18n.t('Content Library'),
          routerLink: { name: 'library-index' },
          icon: 'layers',
        },
        {
          name: i18n.t('Tags'),
          routerLink: { name: 'tags-index' },
          icon: 'tags',
        },
        // {
        //   name: i18n.t('Users'),
        //   routerLink: { name: 'users-index' },
        //   icon: 'users',
        // },
      ],
    ]);
    return {
      navigation,
      dropdownItems: useUserDropdownItems({
        router,
        store,
        i18n,
      }),
    };
  },
});
